import { ReactNode } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { Button } from '@forma/forma-ui-kit';
import Link from '@/components/Link';

import { IMenuItem } from '@/helpers/interfaces/common.interface';

import styles from './submenu-buttons.module.css';

interface SubmenuButtonsProps {
  items: (Omit<IMenuItem, 'name'> & { name: ReactNode, type?: 'image' | 'text' })[],
  onClickItem?: () => void,
}

const SubmenuButtons = ({ items, onClickItem }: SubmenuButtonsProps) => {
  return (
    <div className={styles.root}>
      {items.map(({ id, name, href, icon, type }) => (
        href.startsWith('http')?
          <Button
            key={id}
            as="a"
            href={href}
            viewStyle="secondary"
            size="m"
            onClick={onClickItem}
            className={classNames(styles.button, type === 'image' && styles.withImage)}
            iconClassName={styles.icon}
            icon={icon && <ReactSVG src={icon} wrapper="span" />}
            contentClassName={classNames(type === 'image' && styles.hidden)}
          >
            {name}
          </Button>:
        <Button
          id={id}
          as={Link}
          href={href}
          viewStyle="secondary"
          size="m"
          onClick={onClickItem}
          className={classNames(styles.button, type === 'image' && styles.withImage)}
          iconClassName={styles.icon}
          icon={icon && <ReactSVG src={icon} wrapper="span" />}
          contentClassName={classNames(type === 'image' && styles.hidden)}
          key={href}
        >
          {name}
        </Button>
      ))}
    </div>
  );
};

export default SubmenuButtons;
